export default "__VITE_ASSET__C48KA7E1__"